import { render, staticRenderFns } from "./QNA.vue?vue&type=template&id=687e99dc&scoped=true&"
import script from "./QNA.vue?vue&type=script&lang=js&"
export * from "./QNA.vue?vue&type=script&lang=js&"
import style0 from "./QNA.vue?vue&type=style&index=0&id=687e99dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e99dc",
  null
  
)

export default component.exports